module.exports = __webpack_public_path__ + "img/van_der_Staay.64645513.png";